import { MapMarkerStarIcon } from './MapMarkerStarIcon';

/**
 * author: Michael Irigoyen
 * id B4FB6A62-C598-4E96-8E09-C6A2145EE24C
 * name map-marker-star
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-star.svg
 * tags
 * - Navigation 
 */
export const MapMarkerFavoriteIcon = MapMarkerStarIcon;
export default MapMarkerFavoriteIcon